export default class ProductForView {
  sku: string;
  name: string;
  clientCode: string;
  clientName: string;
  unitId: number;
  unitName: string;
  categoryId: number;
  categoryName: string;
  storageType: string;
  storageTypeName: string;
  inventModel: string;
  inventModelName: string;
  type: string;
  typeName: string;
  sizeDefCode: string;
  externalCode: string;
  thumbnailUrl: string;
  length: number;
  width: number;
  height: number;
  weight: number;
  color: string;
  qtyPerCase: number;
  caseLength: number;
  caseWidth: number;
  caseHeight: number;
  caseWeight: number;
  isActive: boolean;
  parentId: number;
  parentCode: string;
  brandId: number;
  brandName: string;
  madeIn: string;
  creatorUserName: string;
  creationTime: Date;
  imageURL: string;
  dimension: string;
  caseDimension: string;
  isAccessories: boolean;
  isWarranty: boolean;
  warrantyDuration: number;
  lengthOfSerialNo: number;
  productType: string;
  productTypeName: string;
  items: Array<any>;
}
